(function () {
  var BRAND = '#e20c90';
  var BRAND_HOVER = '#b80a76';
  var css =
    '._formSubmitButton_cit2d_96, button[type="submit"]{' +
    'background:' + BRAND + ' !important;' +
    'border-color:' + BRAND + ' !important;' +
    'color:#fff !important;}' +
    '._formSubmitButton_cit2d_96:hover, button[type="submit"]:hover{' +
    'background:' + BRAND_HOVER + ' !important;' +
    'border-color:' + BRAND_HOVER + ' !important;}' +
    'a, ._link{color:' + BRAND + ' !important;}';

  function inject(host) {
    var sr = host && host.shadowRoot;
    if (!sr || sr.querySelector('style[data-cps-brand]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-cps-brand', '1');
    style.textContent = css;
    sr.appendChild(style);
  }

  function scan() {
    document.querySelectorAll('shopify-forms-embed').forEach(inject);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
